module.exports = __webpack_public_path__ + "static/img/pic_home_welcome.e861069.png";


//////////////////
// WEBPACK FOOTER
// ./static/staticPages/pic_home_welcome.png
// module id = UGP5
// module chunks = 83